<template>
    <div>
        <div class="headline">
            <h3>{{ 'Projects in ' + location.name}}</h3>
            <search
                :placeholder= "'Search for Projects in ' + location.name"
                icon="group"
                min_len = '4'
                v-on:searchstr="searchForProjects($event)">

            </search>

        </div>
        <div class="content">
            <ul class="dashboard-box-list">
                <template v-for="(project, index) in projects">
                    <router-link
                        class="task-listing"
                        :key="index"
                        :to="`/project-details?id=${project.id}`"
                    >
                        <!-- Project Listing Details -->
                        <div class="task-listing-details">
                            <!-- Details -->
                            <div class="task-listing-description">
                                <h3 class="task-listing-title text-capitalize">
                                    {{ project.title }}
                                </h3>
                                <ul class="task-icons">
                                    <li>
                                        <i class="icon-material-outline-location-on"></i>
                                        {{ project.region ? project.region.name : "Remote" }}
                                    </li>
                                    <li>
                                        <i class="icon-material-outline-access-time"></i>
                                        Posted:
                                        {{
                                        project.posted_on
                                        ? formatDate(project.posted_on)
                                        : "Not Published"
                                        }}
                                    </li>
                                    <li>
                                        <i class="icon-line-awesome-calendar"></i> Est. Start
                                        Date: {{ formatDate(project.proposed_start_date) }}
                                    </li>
                                    <br />
                                    <li>
                                        <i class="icon-line-awesome-tachometer"></i> Est.
                                        Timeline: {{ project.duration }}
                                    </li>
                                </ul>
                                <p class="task-listing-text">
<!--                                    {{ subString(project.description, 150) }} ...-->
                                <span v-text="readMoreText(project)" :key="readMore"></span>
                                <span><a href="#" v-on:click.prevent="toggleReadMore(project)" class="read-more-link" v-text="readMoreLink(project)"> Read More...</a></span>
                                </p>
                            </div>
                        </div>

                        <div class="task-listing-bid">
                            <div class="task-listing-bid-inner">
                                <div class="task-offers">
                                    <strong>{{ formatAmount(project.budget) }}</strong>
                                    <span>{{
                        project.posted_on ? "Payment verified" : ""
                      }}</span>
                                </div>
                                <span class="button button-sliding-icon ripple-effect">
                      View
                      <i class="icon-material-outline-arrow-right-alt"></i
                      ></span>
                            </div>
                        </div>
                    </router-link>
                </template>

            </ul>

            <br/><br/><br/>

        </div>
    </div>

</template>
<script>
    import {searchProjects} from '../../../../core/services/location-services'
    import Search from "../../../partials/Search"
    import moment from "moment";
    import {
        subString,
        formatDate,
        capitalizeFirstLetter,
        formatAmount,
    } from "../../../../plugins/handlers";

    export default {
        name: 'projects-list',
        props: ['country', 'region', 'city'],
        components: {Search},
        data() {
            return {
                projects : [],
                projectsLoaded : 0,
                currentPage: 0,
                location: '',
                currentLocation: '',
                finishedLoading: 0,
                searchTerm: '',
                searchInfo: '',
                readMore: 0,
                descriptionCharLimit: 100,
            }
        },

        computed: {
        },

        methods : {
            formatAmount(amount) {
                return formatAmount(amount);
            },
            formatDate(dateTime) {
                return formatDate(dateTime);
            },
            capitalizeFirstLetter(string) {
                return capitalizeFirstLetter(string);
            },
            subString(string, length) {
                return subString(string, length);
            },
            readMoreText(project) {
                if(typeof project.readMoreDescription == "undefined") {
                    project.readMoreDescription = 0;
                }
                if(project.readMoreDescription === 0) {
                    return project.description.slice(0,this.descriptionCharLimit);
                } else {
                    return project.description;
                }
            },
            readMoreLink(project) {
                if(typeof project.readMoreDescription == "undefined") {
                    project.readMoreDescription = 0;
                }
                if(project.readMoreDescription === 0) {
                    return " Read More...";
                } else {
                    return " Read Less...";
                }
            },

            searchForProjects(str) {
                this.searchTerm = str;
                this.currentPage = 0;
                this.projects = [];
                this.loadProjects();
            },

            since(project) {
                return 'Since ' + moment(project.created_at).format('MMMM Do, YYYY');
            },

            toggleReadMore(project) {
                if(typeof project.readMoreDescription == "undefined") {
                    project.readMoreDescription = 0;
                }
                if(project.readMoreDescription === 0) {
                    project.readMoreDescription = 1;
                } else {
                    project.readMoreDescription = 0;
                }
                this.readMore++; //increment key
            },
            b4Load() {
                this.searchInfo = '';
                this.currentPage++;
                this.finishedLoading = 1;
                this.projectsLoaded = 0;
            },
            params () {
                let params = {};
                if(this.currentLocation === 'country') {
                    params.country_ids = [this.country.id];
                } else if (this.currentLocation === 'region') {
                    params.region_ids = [this.region.id];
                } else if(this.currentLocation === 'city') {
                    params.city_ids = [this.city.id];
                }
                if(this.searchTerm.length >= 4) {
                    params.searchTerm = this.searchTerm;
                }
                return params;
            },
            loadProjects() {
                searchProjects(
                    this.params(),
                    this.currentPage
                )
                    .then((response) => {

                        if(response.data.data.last_page === response.data.data.current_page) {
                            this.finishedLoading = 1;
                        } else {
                            this.finishedLoading = 0;
                        }
                        this.projects = this.projects.concat(response.data.data.data);

                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.projectsLoaded = 1;
                    });

            }
        },

        created() {
            // Set location to Country or Region or City
            if(this.country !==  undefined  && this.country !== "") {
                this.location = this.country;
                this.currentLocation = 'country';
            }
            if(this.region !== undefined && this.region !== "") {
                this.location = this.region;
                this.currentLocation = 'region';
            }
            if(this.city !== undefined && this.city !== "") {
                this.location = this.city;
                this.currentLocation = 'city';
            }
            this.loadProjects();

        }
    }
</script>

<style scoped>
    .item-description {
    }
    .read-more-link {
        text-decoration: none;
        color: #0fbaf1;
    }
</style>
